module.exports = __webpack_public_path__ + "Icon_Representations.1d70bb94e7e9dd35074b.png";